/**
 * Every module Program Health can show, in display order, with the plan that
 * unlocks it.
 *
 * The server returns figures only for modules the account's plan includes, so
 * this table is what lets the panel still render the rest as locked rows: an
 * absent key means "not on this plan", and this says which plan would have it.
 */
export interface DashboardModuleConfig {
    key: string;
    /** Plan that includes this module, shown on the locked row. */
    unlockedBy: string;
}

export const DASHBOARD_MODULE_ORDER: DashboardModuleConfig[] = [
    { key: "reports", unlockedBy: "Risk Analysis" },
    { key: "hazardRegister", unlockedBy: "SMS Essentials" },
    { key: "riskEvaluations", unlockedBy: "SMS Essentials" },
    { key: "safetyCases", unlockedBy: "SMS Essentials" },
    { key: "actions", unlockedBy: "SMS Essentials" },
    { key: "internalAudits", unlockedBy: "SMS Essentials" },
    { key: "inspections", unlockedBy: "SMS Essentials" },
    { key: "promotions", unlockedBy: "SMS Suite" },
    { key: "safetyObjectives", unlockedBy: "SMS Suite" },
];
